module.exports = __webpack_public_path__ + "img/hero_s@2x-2.1df19ca3.webp";